import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useUserContextStore } from './userContextStore'

export const useMainStore = defineStore('main', () => {
  const userName = ref('')
  const userEmail = ref('')
  const customerContext = ref(null)

  const customerContexts = computed(() => {
    const userContextStore = useUserContextStore()

    if (!userContextStore.permissions?.apps) return []

    return userContextStore.permissions.apps.flatMap(app => {
      if (app.app === 'RUBIX' && app.customer?.cust_no) {
        return app.customer
      }

      return []
    })
  })
  const selectedCustomer = computed(() => {
    return customerContext.value ?? customerContexts.value[0]
  })

  const userAvatar = computed(
    () =>
      `https://api.dicebear.com/7.x/avataaars/svg?seed=${userEmail.value.replace(
        /[^a-z0-9]+/gi,
        '-',
      )}`,
  )

  const isFieldFocusRegistered = ref(false)

  const isNewspaperCustomer = computed(() => {
    const userContextStore = useUserContextStore()
    const permission = userContextStore.permissions?.apps.find(
      p => p.app?.toUpperCase() === 'RUBIX',
    )

    if (permission) {
      return permission.customer?.is_newspaper ?? false
    }
    return false
  })

  function setCustomerContext(context) {
    customerContext.value = context
  }

  function setUser(payload) {
    if (payload.name) {
      userName.value = payload.name
    }
    if (payload.email) {
      userEmail.value = payload.email
    }
  }

  const permittedFunctions = computed(() => {
    const userContextStore = useUserContextStore()
    const app = (userContextStore.permissions?.apps || []).find(
      p => p.app && p.app.toUpperCase() === 'RUBIX',
    )
    const f = Array.from(
      new Set(
        (app?.roles ?? []).flatMap(r => r.functions).map(f => f.function),
      ),
    )
    return f
  })

  function $reset() {
    userEmail.value = ''
    userName.value = ''
  }

  return {
    customerContext,
    customerContexts,
    selectedCustomer,
    userName,
    userEmail,
    userAvatar,
    isFieldFocusRegistered,
    isNewspaperCustomer,
    setCustomerContext,
    setUser,
    permittedFunctions,
    $reset,
  }
})
